import React from 'react';
import UserInsightsComponent from '../../components/user-insights';

const UserInsightsContainer = () => {
    return <UserInsightsComponent />;
};

export default UserInsightsContainer;
